module.exports = __webpack_public_path__ + "img/car_license.04728e05.png";